ViewMachine = App.loadClass "grower::handlers/machinery/DialogViewMachinery_Handler"

class exports.DialogAddMachinery_Handler extends DialogHandler

    init: () ->
        @layoutUrl = "backend/grower/machinery/load-layout-add-machinery"
        @createDialog()


    afterLoadLayout: (selector, response) ->
        @openDialog()

        if response.status?.type isnt 'success'
            return


    submitAction: () ->
        add = @parent.createSubHandler ViewMachine
        if add
            add.saveUrl = 'backend/grower/machinery/save'
            add.wantAdd = true
            add.machinery_type = @dialog.find('#machinery_type_id').val()
            add.init()
